import { Box, SxProps, Theme } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";

import Loading from "~frontend/components/Loading";
import usePrevious from "~frontend/util/usePrevious";

export function GifWithLoadingState({
  loading: loadingProp,
  gifUrl,
  pngUrl,
  pauseOnMouseOff,
  sx,
  onClick,
}: {
  loading?: boolean;
  gifUrl: string;
  pngUrl: string;
  pauseOnMouseOff?: boolean;
  sx?: SxProps<Theme>;
  onClick?: () => any;
}): ReactElement {
  const previousGifUrl = usePrevious(gifUrl);
  const previousPngUrl = usePrevious(pngUrl);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (gifUrl !== previousGifUrl || pngUrl !== previousPngUrl) {
      setLoading(true);
    }
  }, [gifUrl, previousGifUrl, pngUrl, previousPngUrl]);

  const [hovering, setHovering] = useState(false);

  const src = pauseOnMouseOff && !hovering ? pngUrl : gifUrl;

  return (
    <>
      <Box
        sx={{
          position: "relative",
          ...sx,
          ...(loading || loadingProp ? {} : { display: "none" }),
        }}
        onClick={onClick}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      >
        <Loading
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            margin: 0,
          }}
        />
      </Box>
      <Box
        component="img"
        alt="Campaign-supplied gif" // Warning: this text doesn't satisfy WCAG 1.1.1, and is a short-term placeholder for a better solution
        sx={{
          ...sx,
          ...(loading || loadingProp ? { display: "none" } : {}),
        }}
        src={src}
        onClick={onClick}
        onLoad={() => setLoading(false)}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      />
    </>
  );
}
